import { render, staticRenderFns } from "./BbeeProductosServiciosLS.vue?vue&type=template&id=fcb97250"
import script from "./BbeeProductosServiciosLS.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosLS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports